import React from "react";
import CareersSubNav from "../components/careersSubNav";
import { FiZap, FiUsers, FiTarget, FiTrendingUp } from "react-icons/fi";

const points = [
  { title: "Early, and it shows", description: "We're pre-launch. Decisions move fast, roles aren't rigid yet, and what you build now shapes how things work later.", Icon: FiZap },
  { title: "Small team, direct access", description: "No layers between you and the founders — feedback and decisions happen in the same conversation.", Icon: FiUsers },
  { title: "Ownership over tasks", description: "You're given a real outcome to own, not a checklist. How you get there is largely up to you.", Icon: FiTarget },
  { title: "Grows as we grow", description: "Compensation, scope, and team size are all expected to expand as Nirkana does — starting from where we are today.", Icon: FiTrendingUp },
];

const LifeAtNirkana = () => {
  return (
    <div>
      <section className="bg-cloud py-14 lg:py-20">
        <div className="max-w-content mx-auto px-6 lg:px-10">
          <h1 className="text-3xl font-bold text-brand sm:text-4xl">Life at Nirkana</h1>
          <p className="mt-4 max-w-prose text-muted">
            An honest picture of what working here is actually like right
            now — not a polished, post-scale version of it.
          </p>
        </div>
      </section>

      <CareersSubNav />

      <section className="bg-paper py-16 lg:py-24">
        <div className="max-w-content mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 gap-x-10 gap-y-10 md:grid-cols-2">
            {points.map(({ title, description, Icon }) => (
              <div key={title} className="border-t border-line pt-6">
                <Icon className="text-action" size={22} />
                <h3 className="mt-4 text-lg font-semibold text-charcoal">{title}</h3>
                <p className="mt-2 text-sm text-muted">{description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LifeAtNirkana;
